<template>
  <div v-if="data && data.person" class="row-box">
    <!-- основная информация: start -->
    <Block
      :data="data.person"
      :field-group="FieldGroup.PERSON"
      :field-group-edit="fieldGroupEdit"
    />
    <Block
      v-if="personDocumentVisible && identityDocument"
      :data="identityDocument"
      :field-group="FieldGroup.IDENTITY_DOCUMENT"
    />

    <!-- индивидуальный предприниматель: start -->
    <TitleField
      v-if="data.person.isBusinessman"
      fieldName="isBusinessman"
      fieldGroup="person"
      :isApplicant="isApplicant"
      :statementType="statementType"
    />
    <BusinessmenSection
      v-if="data.person.isBusinessman"
      :data="data.person.businessmenInfo"
    />
    <!-- индивидуальный предприниматель: end -->

    <!-- представитель: start -->
    <template v-if="data.person.isTrustee">
      <TitleField fieldName="isTrustee" fieldGroup="person" />
      <TrusteeSection
        v-if="data.person.trusteeInfo"
        :data="trusteeInfoData"
        :documents-hidden="
          trusteeDocumentsHidden || trusteeDocumentsHiddenInner
        "
      />
      <TrusteeOrganization
        v-if="data.person.trusteeOrganizationInfo"
        :data="data.person.trusteeOrganizationInfo"
      />
      <TrusteeForeignOrganization
        v-if="data.person.trusteeForeignOrganizationInfo"
        :data="data.person.trusteeForeignOrganizationInfo"
      />
    </template>
    <!-- представитель: end -->

    <template v-if="data.person.isAssignee">
      <TitleField fieldName="isTrustee" fieldGroup="person" />
      <TrusteeSection
        v-if="data.person.assignee"
        :data="data.person.assignee"
        :documents-hidden="trusteeDocumentsHidden"
        is-assignee
      />
    </template>
  </div>
</template>

<script>
import { createDataField, FieldGroup } from '@/utils/fullStatementView';
import TitleField from '@/components/elements/statement/FullStatementView/base/TitleField';
import TrusteeSection from '@/components/elements/statement/FullStatementView/elements/Trustee';
import TrusteeOrganization from '@/components/elements/statement/FullStatementView/elements/TrusteeOrganization';
import TrusteeForeignOrganization from '@/components/elements/statement/FullStatementView/elements/TrusteeForeignOrganization';
import BusinessmenSection from '@/components/elements/statement/FullStatementView/elements/Businessmen';
import Block from '@/components/elements/statement/FullStatementView/elements/Block';
import { StatementType } from '@/types/services';
import cloneDeep from 'clone-deep';

export default {
  name: 'Person',
  components: {
    TitleField,
    TrusteeSection,
    TrusteeOrganization,
    TrusteeForeignOrganization,
    BusinessmenSection,
    Block,
  },
  props: {
    // основные данные
    data: Object,
    // маппинг person с правкой полей из fieldGroupEdit
    fieldGroupEdit: {
      type: String,
      default: '',
    },
    // данные берутся из applicant, первый шаг
    isApplicant: {
      type: Boolean,
      default: false,
    },
    // тип заявления
    statementType: {
      type: String,
      default: '',
    },
    trusteeDocumentsHidden: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    createDataField,
    FieldGroup,
  }),
  computed: {
    trusteeDocumentsHiddenInner() {
      return [StatementType.ROD].includes(this.statementType);
    },
    personDocumentVisible() {
      return [StatementType.ROD].includes(this.statementType);
    },
    identityDocument() {
      return this.data.identityDocument;
    },
    trusteeInfoData() {
      if (this.trusteeDocumentsHidden) {
        const res = cloneDeep(this.data.person.trusteeInfo);
        delete res.trusteeStatus;

        return res;
      }

      return this.data.person.trusteeInfo;
    },
  },
};
</script>
